import React from 'react';
import AuthWrapper from './components/AuthWrapper';
import './App.css';

function App() {
  return (
    <div className="App">
      <AuthWrapper />
    </div>
  );
}

export default App;
